import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import es from './es';

i18n.use(initReactI18next).init({
  resources: {
    en_US: { translation: en },
    es_ES: { translation: es }
  },
  lng: 'en_US',
  interpolation: { prefix: '%{', suffix: '}', escapeValue: false },
  fallbackLng: 'en_US',
  nsSeparator: '::'
});

export default i18n;
